import { useState } from "react";
import { Link } from "react-router-dom";
import { Rocket, Search } from "lucide-react";
import WalletButton from "@/components/WalletButton";
import LaunchModal from "@/components/LaunchModal";

export default function Navbar() {
  const [launchOpen, setLaunchOpen] = useState(false);

  return (
    <>
      <header className="glass animate-fade-down sticky top-0 z-40 border-b border-white/10">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
          <Link to="/" className="flex items-center gap-2.5 shrink-0" data-testid="logo-link">
            <img
              src="/logo.png"
              alt="BluePad"
              className="h-9 w-9 rounded-xl object-contain drop-shadow-[0_0_10px_rgba(0,82,255,0.55)]"
            />
            <div className="leading-none">
              <div className="font-head text-lg font-extrabold tracking-tight">
                Blue<span className="text-[#38bdf8]">Pad</span>
              </div>
              <div className="font-mono2 text-[10px] uppercase tracking-widest text-slate-500">
                uniswap v4 · base
              </div>
            </div>
          </Link>

          <div className="hidden flex-1 items-center md:flex max-w-md">
            <div className="flex w-full items-center gap-2 rounded-xl border border-white/10 bg-[#0d111a] px-3 py-2">
              <Search size={15} className="text-slate-500" />
              <input
                data-testid="nav-search-input"
                placeholder="Search coins, tickers…"
                className="w-full bg-transparent text-sm text-slate-200 outline-none placeholder:text-slate-600"
                onChange={(e) =>
                  window.dispatchEvent(new CustomEvent("bl-search", { detail: e.target.value }))
                }
              />
            </div>
          </div>

          <div className="flex items-center gap-2 sm:gap-3">
            <button
              data-testid="launch-coin-button"
              onClick={() => setLaunchOpen(true)}
              className="hidden items-center gap-2 rounded-xl border border-white/10 bg-[#131824] px-4 py-2.5 text-sm font-semibold text-slate-100 transition-colors hover:border-blue-500/50 sm:flex"
            >
              <Rocket size={16} className="text-[#00f0ff]" /> Launch
            </button>
            <WalletButton />
          </div>
        </div>
      </header>
      <LaunchModal open={launchOpen} onClose={() => setLaunchOpen(false)} />
    </>
  );
}
